const React = require( 'react' );
const classNames = require( 'classnames' );

require( './loading-overlay.scss' );

const LoadingOverlay = ( props ) => {

        const classes = classNames( {
            'loading-overlay': true,
            'active': props.loading
        } );

        return (
            <div className={ classes }>
                <div className="loading-indicator">
                    <div className="loader "></div>
                </div>
            </div>
        );
    };

module.exports = LoadingOverlay;
